import styled from 'styled-components'
import { MenuIcon } from '../MenuIcon'

export const CONTEXT_MENU_WIDTH = '27px'

export const Wrapper = styled.div`
  height: 16px;
  cursor: pointer;
`

export const MenuTrigger = styled(MenuIcon)`
  width: ${CONTEXT_MENU_WIDTH};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 300ms;
`
